module.exports = __webpack_public_path__ + "carousel-black-1.6d878f79dfa024d430f6537235f02077.jpg";